module.exports = __webpack_public_path__ + "static/media/Explore.0bb98c3d.png";